import { applyMapping, mapDataColumnIndexes } from './mapping';


export async function applyInsertMapping(excelHeaders, mappingParameterization, ctx) {
  const completeMapping = await applyMapping(excelHeaders, mappingParameterization, ctx);
  const { mapping } = completeMapping;
  const { loadEmptyValues } = mappingParameterization;

  const columnIndexSet = new Set();
  mapping.forEach(mappedHeader => columnIndexSet.add(mappedHeader.columnData.columnIndex));
  const columnIndexes = [...columnIndexSet];

  mapDataColumnIndexes(columnIndexes, mapping);

  const processRow = (row, rowIndex) => {
    const object = {};
    const errors = [];

    mapping.forEach(mappedColumn => {
      const { columnData, converter, dataColumnIndex } = mappedColumn;
      const { columnIndex } = columnData;
      
      const { name } = mappedColumn.columnData.rawField;
      const value = row[dataColumnIndex];
      
      if (typeof(value) === 'string' && !value) {
        loadEmptyValues && (object.fieldsToNull = object.fieldsToNull || []).push(name);
      }
      else {
        const { value: convertedValue, error } = converter(value, rowIndex);
        error
          ? errors.push({ error, columnIndex })
          : object[name] = convertedValue;
      }
    });

    return { object, errors };
  };

  return { columnIndexes, processRow, ...completeMapping };
}
